import {STATE_IDLE} from "../const";

export default {
    status: STATE_IDLE,
    token: localStorage.getItem('token') || null,
    user: {},
    lastError: null
};